<template>
  <woot-modal :show="show" :on-close="handleClose" :header-title="$t('IMAGE_LIBRARY.EDIT_ITEM')">
    <div class="space-y-4 p-4">
      <div class="flex items-start gap-4 border border-gray-200 rounded-md p-4 bg-white">
        <div class="w-24 h-24 rounded overflow-hidden bg-gray-100 flex-shrink-0">
          <img :src="item?.thumb_url || item?.file_url" class="w-full h-full object-cover" />
        </div>
        <div class="flex-1 space-y-3">
          <woot-input
            v-model="form.title"
            :label="$t('IMAGE_LIBRARY.FIELDS.TITLE')"
            :placeholder="$t('IMAGE_LIBRARY.FIELDS.TITLE_PLACEHOLDER')"
          />
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">{{ $t('IMAGE_LIBRARY.FIELDS.DESCRIPTION') }}</label>
            <textarea
              v-model="form.description"
              :placeholder="$t('IMAGE_LIBRARY.FIELDS.DESCRIPTION_PLACEHOLDER')"
              rows="6"
              maxlength="1000"
              class="w-full border border-gray-300 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 min-h-[120px]"
            />
            <div class="text-right text-xs text-gray-500 mt-1">{{ (form.description || '').length }}/1000</div>
          </div>
        </div>
      </div>

      <div class="flex justify-end gap-2 pt-2">
        <woot-button variant="clear" :disabled="isSubmitting" @click="handleClose">{{ $t('GENERAL.CANCEL') }}</woot-button>
        <woot-button :is-loading="isSubmitting" :disabled="!form.title" @click="save">{{ $t('GENERAL.SAVE') }}</woot-button>
      </div>
    </div>
  </woot-modal>
  
</template>

<script>
export default {
  name: 'EditItemModal',
  props: {
    show: { type: Boolean, default: false },
    accountId: { type: [String, Number], required: true },
    libraryId: { type: [String, Number], required: true },
    item: { type: Object, default: null },
  },
  emits: ['close', 'saved'],
  data() {
    return {
      form: { title: '', description: '' },
      isSubmitting: false,
    }
  },
  watch: {
    item: {
      handler(v) {
        this.form.title = v?.title || ''
        this.form.description = v?.description || ''
      },
      immediate: true,
    },
    show(v) {
      if (!v) return
      this.form.title = this.item?.title || ''
      this.form.description = this.item?.description || ''
    }
  },
  methods: {
    handleClose() { this.$emit('close') },
    async save() {
      try {
        this.isSubmitting = true
        const payload = { title: this.form.title, description: this.form.description }
        await window.axios.put(`/api/v1/accounts/${this.accountId}/image_libraries/${this.libraryId}/image_items/${this.item.id}`, payload)
        this.$emit('saved')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>



